// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { setNestedInReduxState } from 'redux/helpers'
import initialState from './initialState'

import {
  SET_RCN,
  SET_MONTHLY_REPORTS,
  SET_PROTECTION_METRICS,
} from './types'

const protection = (state = initialState, action) => {
  switch (action.type) {
    case SET_MONTHLY_REPORTS :
      return setNestedInReduxState(
        state,
        'monthlyReports',
        {
          ...state.monthlyReports,
          dataExpiration: action.dataExpiration,
          licensees: action.licensees,
          reportCodes: action.reportCodes,
          reports: action.reports,
        }
      )

    case SET_RCN :
      return setNestedInReduxState(
        state,
        'rcn',
        {
          ...state.rcn,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    case SET_PROTECTION_METRICS :
      return setNestedInReduxState(
        state,
        'protectionMetrics',
        {
          ...state.protectionMetrics,
          data: action.data,
          dataExpiration: action.dataExpiration,
        }
      )

    default :
      return state
  }
}

export default protection
